import { render, staticRenderFns } from "./ViewerProgress.vue?vue&type=template&id=525382a4&scoped=true"
import script from "./ViewerProgress.vue?vue&type=script&lang=js"
export * from "./ViewerProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525382a4",
  null
  
)

export default component.exports